/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

export default function Option({ option, value, setValue }) {
  return (
    <li className="py-1 px-3">
      <label className="flex items-center">
        <input
          type="checkbox"
          className="form-checkbox"
          checked={value?.includes?.(option.value)}
          onChange={() => {
            setValue(option.value);
          }}
        />
        <span className="text-sm font-medium ml-2">{option.label}</span>
      </label>
    </li>
  );
}
